export const NORMAL_MODE = "NORMAL_MODE";
export const BOOKING_MODE = "BOOKING_MODE";
export const AVAILABILITY_MODE = "AVAILABILITY_MODE";
